"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Close = createSVGIconV2(
  <>
    <path d="M2.5 2.5L21.5 21.5" stroke="currentColor" strokeLinecap="round" />
    <path d="M21.5 2.5L2.5 21.5" stroke="currentColor" strokeLinecap="round" />
  </>,
  "Close",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    color: Core.icon.primary,
    titleAccess: strictLocalize({
      id: "CO1Zce",
      defaultMessage: "Close",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: iconCls(),
  })
);
